<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          display: flex;
          align-items: center;
          padding: 10px 20px;
        "
      >
        <li style="font-size: 13px">银行到账操作</li>
        <li
          style="
            flex: 1;
            text-align: center;
            font-weight: 600;
            display: flex;
            justify-content: flex-end;
          "
        >
          <el-button
            type="warning"
            link
            icon="SwitchButton"
            @click="onFreeze"
            v-if="$judge_auth('128')"
          >
            冻结
          </el-button>
        </li>
      </ul>
      <div style="flex: 1; overflow: auto; padding: 10px">
        <div style="font-weight: 600; font-size: 13px">基本信息</div>
        <el-descriptions
          :column="4"
          border
          style="overflow-x: auto; margin-top: 10px"
          class="desc-label-nowrap"
        >
          <el-descriptions-item label="到账ID" label-align="right">
            <div style="width: 200px">
              {{ state.model.id }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="到账银行" label-align="right">
            <div style="width: 200px">
              <component
                :is="
                  $statusFormat2(
                    'bankReceived_collected_status',
                    state.model.collected_status
                  )
                "
              />
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="到账银行" label-align="right">
            <div style="width: 200px">
              {{ state.model.bank_account?.opening_bank || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="付款人/付款银行" label-align="right">
            <div style="width: 200px">
              {{ state.model.payment_name
              }}<text v-if="state.model.payment_bank" style="color: #a2a2a2">
                {{ "/" + state.model.payment_bank }}
              </text>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="摘要信息" label-align="right">
            <div style="width: 200px">
              {{ state.model.summary || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="到账金额" label-align="right">
            <div style="width: 200px">
              {{ $priceFormat(state.model.received_amount) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="到账时间" label-align="right">
            <div style="width: 200px">
              {{ state.model.received_date || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="实际到账金额" label-align="right">
            <div style="width: 200px">
              <c_money :value="parseFloat(state.model.real_received_amount)" />
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="手续费" label-align="right">
            <div style="width: 200px">
              {{ $priceFormat(state.model?.service_fee) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="已认领金额" label-align="right">
            <div style="width: 200px">
              {{ $priceFormat(state.model?.collected_amount) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="认领中金额" label-align="right">
            <div style="width: 200px">
              {{ $priceFormat(state.model?.collecting_amount) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="未认领金额" label-align="right">
            <div style="width: 200px; display: flex">
              {{ $priceFormat(state.model?.uncollected_amount) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="创建人" label-align="right" :span="2">
            <div style="width: 400px; display: flex">
              {{ state.model.add_admin_name }}
              <text v-if="state.model.add_department_name">
                {{ "/" + state.model.add_department_name }}
              </text>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间" label-align="right">
            <div style="width: 200px; display: flex">
              {{ state.model.create_time }}
            </div>
          </el-descriptions-item>
        </el-descriptions>
        <template v-if="state.rlzData?.length > 0">
          <div style="font-weight: 600; font-size: 13px; margin-top: 10px">
            认领确认
          </div>
          <div
            v-for="item in state.rlzData"
            :key="item"
            style=""
            class="bankreceived-detail-rlzbox"
          >
            <div class="bankreceived-detail-rlzbox-content">
              <div>
                <li>状态：</li>
                <li>
                  <c_status
                    arr-name="bankcollected_status"
                    :value="item.status"
                  ></c_status>
                </li>
              </div>
              <div>
                <li>认领金额：</li>
                <li>
                  <c_money :value="parseFloat(item.collect_amount)"></c_money>
                </li>
              </div>
              <div>
                <li>认领人：</li>
                <li>
                  {{ item.add_admin_name + "/" + item.add_department_name }}
                </li>
              </div>
              <div>
                <li>认领时间：</li>
                {{ $dayjs(item.create_time).format("YYYY-MM-DD") }}
              </div>
              <div>
                <li style="">认领用途：</li>
                <li>
                  {{ item.bank_received_type }}
                </li>
              </div>
              <div>
                <li>工资表单号：</li>
                <li>
                  {{ item.payroll_order_id || "-" }}
                </li>
              </div>
              <!-- <div>
                <li>认领单号：</li>
                <li>
                  {{ item.order_id }}
                </li>
              </div> -->
              <div style="width: 100%">
                <li>认领说明：</li>
                <li>
                  {{ item.collect_remark }}
                </li>
              </div>
            </div>
            <div
              style="
                margin-left: 100px;
                display: flex;
                align-items: center;
                margin-right: 10px;
              "
              v-if="$judge_auth('128')"
            >
              <el-button
                link
                type="warning"
                size="small"
                @click="onCheck(item, 2)"
              >
                取消认领
              </el-button>
              <el-button type="primary" @click="onCheck(item, 1)"
                >确认认领</el-button
              >
            </div>
          </div>
        </template>
        <template v-if="state.yrlData?.length > 0">
          <div style="margin-top: 10px; display: flex; align-items: center">
            <text style="font-weight: 600; font-size: 13px">认领记录</text>
            <div
              style="
                flex: 1;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                color: #a2a2a2;
                font-size: var(--tab-group-second-font-size);
              "
              v-html="
                Object.keys(state.model.collected_amount_detail?.collected)
                  .map(
                    (key) =>
                      `${key}: <text style='color:#ffa500;margin-right:5px;font-size:16px'>${$priceFormat(
                        state.model.collected_amount_detail?.collected[key]
                      )}</text>`
                  )
                  .join(' ')
              "
            ></div>
          </div>
          <el-table :data="state.yrlData" style="margin-top: 10px">
            <el-table-column
              fixed
              label="序号"
              width="70"
              type="index"
              align="center"
            />
            <el-table-column
              label="状态"
              prop="status"
              sortable="status"
              :formatter="
                (row, column, cellValue) =>
                  $statusFormat2('bankcollected_status', cellValue)
              "
            />
            <el-table-column label="认领用途" prop="bank_received_type">
              <template #default="{ row }">
                <c_tabgroup
                  v-if="
                    ['工资', '个税', '服务费'].includes(row.bank_received_type)
                  "
                  :value1="row.bank_received_type"
                  :value2="row.payroll?.order_id || ''"
                >
                </c_tabgroup>
                <text v-else>{{ row.bank_received_type }}</text>
              </template>
            </el-table-column>
            <el-table-column
              label="认领金额"
              prop="collect_amount"
              sortable="collect_amount"
              :formatter="$tab_MoneyFormat"
            />
            <el-table-column
              label="认领单号"
              prop="order_id"
              :formatter="$tab_TextFormat"
            />
            <el-table-column
              label="认领人"
              prop="add_admin_name"
              :formatter="
                (row) => row.add_admin_name + '/' + row.add_department_name
              "
            />
            <el-table-column
              label="认领时间"
              prop="create_time"
              :formatter="$tab_TextFormat"
            />
            <el-table-column
              label="认领说明"
              prop="collect_remark"
              :formatter="$tab_ShowToolTip"
            />
            <el-table-column
              label="更新人"
              :formatter="
                (row) =>
                  row.add_admin_name
                    ? row.add_admin_name + '/' + row.add_department_name
                    : '-'
              "
            />
            <el-table-column
              label="更新时间"
              prop="update_time"
              :formatter="$tab_TextFormat"
            />
            <el-table-column
              label="操作"
              width="100"
              fixed="right"
              align="center"
              v-if="$judge_auth('128')"
            >
              <template #default="{ row }">
                <el-button
                  v-if="row.status == 1"
                  size="small"
                  type="info"
                  @click="onBack(row.id)"
                >
                  撤回
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  bankreceived_detail,
  bankreceived_getcollects,
  bankreceived_freeze,
  bankreceived_check,
  bankreceived_back,
} from "@/http/bankreceived";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  props: {
    data: Object,
  },
  setup(props) {
    const state = reactive({
      model: {},
      rlzData: [],
      yrlData: [],
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      bankreceived_detail(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });

      bankreceived_getcollects(props.data.id).then((res) => {
        if (res.status == 200) {
          const { collected, collect } = res.data.data;
          state.rlzData = collect;
          state.yrlData = collected;
        }
      });
    };

    //冻结
    const onFreeze = () => {
      ElMessageBox.confirm(
        `您确定<strong style='color:#f00'>冻结</strong>该到款记录吗？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        bankreceived_freeze({
          id: props.data?.id,
          freeze_status: 1,
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    //认领
    const onCheck = (item, status) => {
      ElMessageBox.confirm(
        `本次认领金额为<strong style='color:#f00'>${
          item.collect_amount
        }</strong>,您确定${
          status == 1
            ? '<strong style="color:#080">同意</strong>'
            : '<strong style="color:#f00">拒绝</strong>'
        }该认领请求吗？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        bankreceived_check({
          bank_collected_id: item.id,
          collected_status: status,
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onBack = (id) => {
      ElMessageBox.confirm(
        `您确定<strong style='color:#ffa500'>撤回</strong>该认领记录吗？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        bankreceived_back({
          bank_collected_id: id,
        }).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };
    return { state, props, onFreeze, onCheck, onBack };
  },
};
</script>
<style scoped lang="less">
.bankreceived-detail-rlzbox {
  box-shadow: 0 0 10px 1px #e2e2e2;
  padding: 20px 10px;
  border-radius: 7px;
  margin-top: 10px;
  display: flex;

  & > .bankreceived-detail-rlzbox-content {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    font-size: 13px;
    overflow: hidden;

    & > div {
      width: 33.33%;
      display: flex;
      align-items: flex-start;
      overflow: hidden;
      min-height: 30px;

      & > li:first-child {
        width: 100px;
        text-align: right;
        color: #a2a2a2;
      }
    }
  }
}
</style>
